import React from 'react';
import '../styles/Pages.css';
import canamLogo from '../images/CanAm Logo.png';

const ContactPage = () => (
  <div className="page-container">
    <div className="page-content">
      <div className="page-title-row">
        <img src={canamLogo} alt="CanAm Logo" className="page-title-logo" />
        <h2>Save Our Number</h2>
      </div>

      <div className="info-section" style={{ textAlign: 'center' }}>
        <p className="event-description" style={{ marginBottom: '1.5rem' }}>
          Event texts come from <strong>(716) 249-3421</strong>. Save us as a contact so you'll
          always know it's CanAm Games when we reach out about the event.
        </p>
        <a href="/contact.vcf" className="save-contact-btn">📇 Save “CanAm Games” to Contacts</a>
        <p className="event-description" style={{ marginTop: '1.25rem', fontSize: '0.9rem', color: '#888' }}>
          Tap the button, then choose “Add Contact” / “Create New Contact” on your phone.
        </p>
      </div>
    </div>
  </div>
);

export default ContactPage;
